import Vue from "vue";
import App from "./App.vue";
import weblog from "../../../utils/log";
import "@/assets/css/reset.less";
import Locale from "../../../utils/locale";

Locale.add({
    "zh-cn": {
        noTemplate: '很抱歉，没有找到对应的模版～',
        clickToView: '点击右上角“去看看”其它作品',
        useCount: '使用量',
        toUse: '一键剪同款',
        title: '我在快影发现了超好用的模板...',
        shareIcon: 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/fontend-activity/ky-work-share-topbar.7d6edc0b4e6a2f14.png'
    },
    "en-us": {
        noTemplate: 'sorry, no such template found～',
        useCount: 'Usage amount',
        title: 'I found a super easy-to-use template in KwaiCut...',
        toUse: 'Try This Template',
        clickToView: 'Click "Take a look" in the upper right corner to see other works',
        shareIcon: 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/share.35b4399246d89b15.png'
    },
});
Vue.use(Locale);

console.log('Locale.lang', Locale.t('toUse'));
Vue.prototype.$audioPlayer = new Audio();
Vue.prototype.$weblog = weblog;
Vue.config.productionTip = false;
Vue.config.ignoredElements = ["wx-open-launch-app"];


new Vue({
    render: h => h(App),
}).$mount("#app");
